import { AppData } from '@/types';
import { demoMembers, demoPersonalInfo } from './family-tree';
import { demoUsers } from './users';
import { demoSharedLinks } from './shared-links';
import { demoRequests } from './requests';


export const demoData: AppData = {
  users: demoUsers,
  members: demoMembers,
  personalInfos: demoPersonalInfo,
  sharedLinks: demoSharedLinks,
  requests: demoRequests,
  registerRequests: [],
  lastUpdated: Date.now()
};


export {
  demoUsers,
  demoMembers,
  demoPersonalInfo,
  demoSharedLinks,
  demoRequests
};